import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import annualReport202425 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2024-25.pdf";
import annualReport202324 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2023-24.pdf";
import annualReport202223 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2022-23.pdf";
import annualReport202122 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2021-22.pdf";
import annualReport202021 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2020-21.pdf";
import annualReport201920 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2019-20.pdf";
import annualReport201819 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2018-19.pdf";
import annualReport201718 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2017-18.pdf";
import annualReport201617 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2016-17.pdf";
import annualReport201415 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2014-15.pdf";
import annualReport201314 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2013-14.pdf";
import annualReport201213 from "../../../../assets/tenders/resource/annual_reports/Annual Report 2012-13.pdf";

const annualReports = [
  {
    serial: 1,
    title: "Annual Report 2024-25",
    fileName: "Annual Report 2024-25.pdf",
    href: annualReport202425,
  },
  {
    serial: 2,
    title: "Annual Report 2023-24",
    fileName: "Annual Report 2023-24.pdf",
    href: annualReport202324,
  },
  {
    serial: 3,
    title: "Annual Report 2022-23",
    fileName: "Annual Report 2022-23.pdf",
    href: annualReport202223,
  },
  {
    serial: 4,
    title: "Annual Report 2021-22",
    fileName: "Annual Report 2021-22.pdf",
    href: annualReport202122,
  },
  {
    serial: 5,
    title: "Annual Report 2020-21",
    fileName: "Annual Report 2020-21.pdf",
    href: annualReport202021,
  },
  {
    serial: 6,
    title: "Annual Report 2019-20",
    fileName: "Annual Report 2019-20.pdf",
    href: annualReport201920,
  },
  {
    serial: 7,
    title: "Annual Report 2018-19",
    fileName: "Annual Report 2018-19.pdf",
    href: annualReport201819,
  },
  {
    serial: 8,
    title: "Annual Report 2017-18",
    fileName: "Annual Report 2017-18.pdf",
    href: annualReport201718,
  },
  {
    serial: 9,
    title: "Annual Report 2016-17",
    fileName: "Annual Report 2016-17.pdf",
    href: annualReport201617,
  },
  {
    serial: 10,
    title: "Annual Report 2014-15",
    fileName: "Annual Report 2014-15.pdf",
    href: annualReport201415,
  },
  {
    serial: 11,
    title: "Annual Report 2013-14",
    fileName: "Annual Report 2013-14.pdf",
    href: annualReport201314,
  },
  {
    serial: 12,
    title: "Annual Report 2012-13",
    fileName: "Annual Report 2012-13.pdf",
    href: annualReport201213,
  },
];

const AnnualReports = () => (
  <section className="min-w-0 flex-1">
    <PdfDocumentTable
      documents={annualReports}
      titleHeader="Annual Report"
      minWidth="720px"
    />
  </section>
);

export default AnnualReports;
